'use strict';
var $ = require('../internals/export');
var globalThis = require('../internals/global-this');

// `globalThis` object
// https://tc39.es/ecma262/#sec-globalthis
$({ global: true, forced: globalThis.globalThis !== globalThis }, {
  globalThis: globalThis
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.global-this.js
// module id = 754
// module chunks = 0